if (!customElements.get('scroll-top-button')) {
  customElements.define(
  'scroll-top-button',
  class ScrollToTopButton extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const buttons = this.querySelectorAll('button');
      [...buttons].forEach((button) => button.addEventListener('click', this.handleScrollTop.bind(this)));
      // this.onScrollHandler = this.onScroll.bind(this);
      // window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disconnectedCallback() {
      // window.removeEventListener('scroll', this.onScrollHandler);
    }

    // onScroll() {
    //   const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    //   if (scrollTop > 400) {
    //     requestAnimationFrame(this.show.bind(this));
    //   } else {
    //     requestAnimationFrame(this.hide.bind(this));
    //   }
    // }

    handleScrollTop(event) {
      event.preventDefault();
      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    }

    // hide() {
    //   this.classList.remove('active');
    // }

    // show() {
    //   this.classList.add('active');
    // }
  });
}